import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardoImageElement from '../CardoImageElement';
import CardoLabel from '../CardoLabel';

const generateCardoImageClassNames = ({ zoomOnHover, shrinkOnHover, fixedHeight }) => classNames(
  'cardo__image',
  {
    'cardo__image--zoom': zoomOnHover,
    'cardo__image--shrink': shrinkOnHover,
    'cardo__image--fixed-height': fixedHeight,
  },
);

const CardoImage = ({
  src,
  srcset,
  url,
  alt,
  cover,
  zoomOnHover,
  shrinkOnHover,
  fixedHeight,
  label,
  linkText,
  doNotLazyLoad,
  imageDecode,
  disableProgressiveLoading,
}) => (
  <div className={generateCardoImageClassNames({ zoomOnHover, shrinkOnHover, fixedHeight })}>
    {label && (
      <CardoLabel label={label} />
    )}
    <CardoImageElement
      alt={alt}
      url={url}
      src={src}
      srcset={srcset}
      cover={cover}
      fixedHeight={fixedHeight}
      linkText={linkText}
      doNotLazyLoad={doNotLazyLoad}
      imageDecode={imageDecode}
      disableProgressiveLoading={disableProgressiveLoading}
    />
  </div>
);

CardoImage.propTypes = {
  src: PropTypes.string.isRequired,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  url: PropTypes.string,
  alt: PropTypes.string,
  cover: PropTypes.bool,
  zoomOnHover: PropTypes.bool,
  shrinkOnHover: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  label: PropTypes.string,
  linkText: PropTypes.string,
  doNotLazyLoad: PropTypes.bool,
  imageDecode: PropTypes.string,
  disableProgressiveLoading: PropTypes.bool,
};

export default React.memo(CardoImage);
